module.exports = __webpack_public_path__ + "img/vehicle_menu_normal.fe45dd1a.svg";